const sliceName = "promotion";
const initialState = {
	usePromotion: false,
	loading: false,
	promotionBets: {
		data: [],
		isMulti: false,
		totalFactor: null,
		possibleWin: null,
	},
	rules: {
		isLoading: false,
		showRules: false,
		data: {},
	}
}

export { sliceName, initialState };